import { render, staticRenderFns } from "./PixelEditDetails.vue?vue&type=template&id=0c206bbc&"
import script from "./PixelEditDetails.vue?vue&type=script&lang=js&"
export * from "./PixelEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports